import { SORT, SEARCH } from 'constants/FilterConstants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import * as types from 'modules/payers/actionTypes';
import { getPersistedFilters } from 'services/StateLoader';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {'text' | 'sort' } FilterPayerField */

/** @typedef {Record<FilterPayerField, string | number | Array<string> | Array<number>>} PayersFiltersReducer */

const persistedFilters = getPersistedFilters()?.filters?.payers ?? {};

const emptyState = {
  [SEARCH]: null,
  [SORT]: 'modifiedOn,desc',
};

/** @type {FilterAdapter<PayersFiltersReducer>} */
const filterAdapter = filterSliceAdapter(emptyState, persistedFilters);

export default createReducer(filterAdapter.getInitialState(), {
  [types.SET_PAYERS_DASHBOARD_FILTER]: filterAdapter.setFilter,
  [types.CLEAR_PAYERS_DASHBOARD_FILTER]: filterAdapter.resetFilters,
  [types.REMOVE_PAYERS_DASHBOARD_FILTER]: filterAdapter.removeFilter,
});
